// extracted by mini-css-extract-plugin
export default {"optional":"form-dateselector_optional__hpULC","error":"form-dateselector_error__0gIpb","label":"form-dateselector_label__h7dKt","stretch":"form-dateselector_stretch__W9GAi"};